import { useState } from "react";
import "./index.scss";

const VIDEO_ID = "KG-B8U-DSbY";
const TITLE = "Chirag Boghara - Flutter Developer Introduction";

// Shows the thumbnail first and only loads the YouTube player on click,
// so the page doesn't pull ~1MB of player scripts up front.
const IntroVideo = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="intro-video">
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
          title={TITLE}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          className="intro-video-poster"
          onClick={() => setPlaying(true)}
          aria-label={`Play video: ${TITLE}`}
        >
          <img
            src={`https://i.ytimg.com/vi_webp/${VIDEO_ID}/sddefault.webp`}
            alt=""
            loading="lazy"
          />
          <span className="intro-video-play" aria-hidden="true" />
          <span className="intro-video-label">Watch my intro</span>
        </button>
      )}
    </div>
  );
};

export default IntroVideo;
